import { wx, wxPromisify, wxBridge } from '@tencent/wphk-base-wx';

export async function canIUse(api: wx.Method) {
  const res = await wxCheckJsApi([api]);
  return res[api];
}

export async function wxCheckJsApi(list: wx.Method[]) {
  const res = await wxPromisify(wx.checkJsApi)({
    jsApiList: list,
  }) as {
    checkResult: {
      [key: string]: boolean
    }
  };
  return res.checkResult;
}

/**
 * H5直接唤起小程序API
 * @param params
 */
export async function wxOpenBusinessView(params: OpenBusinessViewParams) {
  return wxPromisify(wx.openBusinessView)(params);
}

interface OpenBusinessViewParams {
  /** 小程序的业务类型，申请小程序可拉起H5权限时填写  */
  businessType: string;
  /** 要打开的小程序版本，有效值 develop（开发）、trial（体验版）、release（正式），默认release */
  envVersion?: OpenBusinessViewEnv;
  /** 打开的页面的查询参数字符串 */
  queryString?: string;
  /** 来源页面公众号 appid，如果没有使用 JSSDK 鉴权，此参数必填 */
  referrerAppid?: string;
}

/**
 * 拉起原生刷卡参数
 */
export interface OpenHKOfflinePayViewParams {
  /** appID */
  appId: string;
  /** 时间戳 */
  timeStamp: string;
  /** 随机字符串 */
  nonceStr: string;
  /** 签名sign */
  paySign: string;
  /** 签名方式（SHA1） */
  signType: string;
  /** 扩展字符串，由商户按规范拼接 */
  package: string;
}

/**
 * 拉起原生刷卡
 * @param params
 * @returns
 */
export function openHKOfflinePayView(params: OpenHKOfflinePayViewParams) {
  return new Promise((resolve) => {
    wxBridge.safeInvoke('openHKOfflinePayView', params, (res) => {
      resolve(res);
    });
  });
}

export enum OpenBusinessViewEnv {
  DEV = 'develop',
  TRIAL = 'trial',
  RELEASE = 'release'
}
